export default __webpack_public_path__ + "static/media/Linevoltage.9b914b8d.svg";